<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>Detalhes de Folheto</h6>
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <p class="text-sm mb-0">
          <span class="font-weight-bold">{{ supermercadosAtivos.length }}</span> supermercados ativos
        </p>
        <button
          @click="loadSupermercados"
          class="btn btn-sm"
          :class="loading ? 'btn-secondary' : 'btn-custom-gradient'"
          :disabled="loading"
        >
          {{ loading ? 'Carregando...' : 'Atualizar' }}
        </button>
      </div>
    </div>
    <div class="card-body">
      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border spinner-teal" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
      </div>
      <div v-else class="row">
        <div
          v-for="supermercado in supermercadosAtivos"
          :key="supermercado.id"
          class="col-md-4 col-lg-3 mb-4"
        >
          <div class="card supermercado-card h-100">
            <div class="card-body text-center d-flex flex-column">
              <div class="supermercado-icon mb-3">
                <i class="fas fa-store fa-2x text-info"></i>
              </div>
              <h6 class="mb-1 text-sm">{{ supermercado.nome || supermercado.name }}</h6>
              <p class="text-xs text-secondary mb-2">
                CNPJ: {{ supermercado.cnpj || supermercado.CNPJ || 'N/A' }}
              </p>
              <div class="mb-3">
                <soft-badge
                  :color="getStatusColor(supermercado.status || supermercado.ativo)"
                  variant="gradient"
                  size="sm"
                >
                  {{ getStatusText(supermercado.status || supermercado.ativo) }}
                </soft-badge>
              </div>
              <div class="d-flex justify-content-center gap-2 mt-auto">
                <button
                  @click="showProducts(supermercado)"
                  class="btn btn-sm btn-custom-gradient"
                >
                  <i class="fas fa-shopping-cart me-1"></i>
                  Produtos
                </button>
                <button
                  @click="openLogsModal(supermercado)"
                  class="btn btn-sm btn-outline-info"
                >
                  <i class="fas fa-history me-1"></i>
                  Logs
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="supermercadosAtivos.length === 0" class="col-12 text-center py-4">
          <p class="text-secondary">Nenhum supermercado ativo encontrado</p>
        </div>
      </div>
    </div>

    <!-- Modal de Produtos -->
    <div v-if="showProductsModal" class="modal-backdrop fade show" @click="closeProductsModal" style="z-index: 9999;"></div>
    <div v-if="showProductsModal" class="modal fade show d-block" tabindex="-1" aria-labelledby="supermarketProductsModalLabel" aria-hidden="true" style="z-index: 10000;">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="supermarketProductsModalLabel">
              <i class="fas fa-shopping-cart me-2"></i>
              Produtos - {{ selectedSupermarketForProducts?.nome || selectedSupermarketForProducts?.name || '' }}
            </h5>
            <button type="button" class="btn-close" @click="closeProductsModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="loadingProducts" class="text-center py-4">
              <div class="spinner-border spinner-teal" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2">Carregando produtos...</p>
            </div>
            <div v-else-if="productsError" class="alert alert-danger">
              {{ productsError }}
            </div>
            <div v-else-if="productsData.length === 0" class="text-center py-4">
              <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
              <p class="text-muted">Nenhum produto encontrado para este supermercado</p>
            </div>
            <div v-else class="table-responsive products-table-wrap">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" style="width: 80px;">
                      Imagem
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Produto
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Quantidade
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Preço
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Ações
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in productsData" :key="item.id">
                    <td class="align-middle">
                      <div class="d-flex align-items-center justify-content-center">
                        <img
                          v-if="getProductImageUrl(item)"
                          :src="getProductImageUrl(item)"
                          :alt="item.product?.name || 'Produto'"
                          class="product-row-thumb"
                          @error="$event.target.style.display = 'none'"
                        />
                        <i v-else class="fas fa-box-open text-secondary"></i>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ item.product?.name || 'Sem nome' }}</h6>
                          <p v-if="item.product?.brand" class="text-xs text-secondary mb-0">
                            {{ item.product.brand }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ item.product?.quantity }} {{ item.product?.unit }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-success font-weight-bold">
                        R$ {{ formatPrice(item.price) }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <button
                        class="btn btn-sm btn-outline-danger"
                        :disabled="deactivatingPriceIds.has(item.id)"
                        @click="deactivateProductPrice(item)"
                      >
                        <span v-if="deactivatingPriceIds.has(item.id)">
                          <i class="fas fa-circle-notch fa-spin"></i>
                        </span>
                        <span v-else>
                          <i class="fas fa-power-off me-1"></i>Desativar
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeProductsModal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Logs de Folhetos -->
    <div v-if="showLogsModal" class="modal-backdrop fade show" @click="closeLogsModal" style="z-index: 9999;"></div>
    <div v-if="showLogsModal" class="modal fade show d-block" tabindex="-1" aria-labelledby="flyerLogsModalLabel" aria-hidden="true" style="z-index: 10000;">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="flyerLogsModalLabel">
              <i class="fas fa-history me-2"></i>
              Logs de Folhetos - {{ logsSupermarket?.nome || logsSupermarket?.name || '' }}
            </h5>
            <button type="button" class="btn-close" @click="closeLogsModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="loadingLogs" class="text-center py-4">
              <div class="spinner-border spinner-teal" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2">Carregando logs de folhetos...</p>
            </div>
            <div v-else-if="logsError" class="alert alert-danger">
              {{ logsError }}
            </div>
            <div v-else-if="flyerLogs.length === 0" class="text-center py-4">
              <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
              <p class="text-muted">Nenhum folheto registrado para este supermercado</p>
            </div>
            <div v-else class="flyer-logs-list">
              <div v-for="log in flyerLogs" :key="log.id" class="flyer-log-item">
                <div class="flyer-log-main">
                  <div
                    class="flyer-log-thumb"
                    :class="{ 'flyer-log-thumb--clickable': getFlyerImageUrl(log) }"
                    @click="getFlyerImageUrl(log) && openImageLightbox(getFlyerImageUrl(log))"
                    title="Ver imagem ampliada"
                  >
                    <img
                      v-if="getFlyerImageUrl(log)"
                      :src="getFlyerImageUrl(log)"
                      alt="Folheto"
                      @error="$event.target.style.display = 'none'"
                    />
                    <i v-else class="fas fa-file-image flyer-log-no-img"></i>
                  </div>
                  <div class="flyer-log-info">
                    <div class="flyer-log-row">
                      <span class="flyer-log-label"><i class="fas fa-calendar-day me-1"></i>Data</span>
                      <span class="flyer-log-value">{{ formatDateTime(log.created_at || log.date) }}</span>
                    </div>
                    <div class="flyer-log-row">
                      <span class="flyer-log-label"><i class="fas fa-user me-1"></i>Adicionado por</span>
                      <span class="flyer-log-value">
                        {{ getUserName(log) }}
                      </span>
                    </div>
                    <div class="flyer-log-row">
                      <span class="flyer-log-label"><i class="fas fa-box me-1"></i>Produtos</span>
                      <span class="flyer-log-value">
                        {{ log.flyer_product_prices_count ?? log.products_count ?? log.quantity ?? log.total_products ?? (Array.isArray(log.products) ? log.products.length : 'N/A') }}
                      </span>
                    </div>
                    <div class="flyer-log-row">
                      <span class="flyer-log-label"><i class="fas fa-calendar-check me-1"></i>Validade</span>
                      <span
                        v-if="log.expires_at || log.valid_until || log.validity"
                        class="flyer-log-value"
                        :class="{ 'text-danger': isExpired(log.expires_at || log.valid_until || log.validity) }"
                      >
                        {{ formatDateShort(log.expires_at || log.valid_until || log.validity) }}
                      </span>
                      <span v-else class="flyer-log-value text-secondary">—</span>
                    </div>
                  </div>
                </div>
                <div class="flyer-log-footer">
                  <router-link
                    :to="{ name: 'FlyerProdutos', params: { id: log.id } }"
                    class="btn btn-sm btn-outline-info"
                  >
                    <i class="fas fa-box-open me-1"></i>
                    Ver Produtos do Folheto
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeLogsModal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Lightbox de imagem ampliada do folheto -->
    <div v-if="showImageLightbox" class="modal-backdrop fade show" @click="closeImageLightbox" style="z-index: 10999;"></div>
    <div v-if="showImageLightbox" class="image-lightbox" @click="closeImageLightbox" style="z-index: 11000;">
      <button type="button" class="image-lightbox-close" @click.stop="closeImageLightbox" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
      <img :src="lightboxImageUrl" alt="Folheto ampliado" class="image-lightbox-img" @click.stop />
    </div>
  </div>
</template>

<script>
import SoftBadge from "@/components/SoftBadge.vue";
import { API_ENDPOINTS, apiRequest, handleApiResponse, STORAGE_BASE_URL } from "@/config/api.js";
import { showSuccessAlert, showErrorAlert, showConfirmAlert } from "@/utils/swal.js";

export default {
  name: "supermercados-ativos-cards",
  components: {
    SoftBadge,
  },
  data() {
    return {
      supermercados: [],
      loading: false,
      error: null,
      showProductsModal: false,
      selectedSupermarketForProducts: null,
      loadingProducts: false,
      productsError: null,
      productsData: [],
      deactivatingPriceIds: new Set(),
      showLogsModal: false,
      logsSupermarket: null,
      loadingLogs: false,
      logsError: null,
      flyerLogs: [],
      showImageLightbox: false,
      lightboxImageUrl: null,
    };
  },
  computed: {
    supermercadosAtivos() {
      return this.supermercados.filter((supermercado) => {
        const status = supermercado.status ?? supermercado.ativo;
        return status === true || status === "ativo" || status === "active";
      });
    },
  },
  mounted() {
    this.loadSupermercados();
  },
  methods: {
    async loadSupermercados() {
      this.loading = true;
      this.error = null;

      try {
        const response = await apiRequest(API_ENDPOINTS.SUPERMARKET, {
          method: "GET",
        });

        const data = await handleApiResponse(response);
        this.supermercados = Array.isArray(data) ? data : (data.data || data.supermercados || []);
      } catch (error) {
        console.error("Erro ao carregar supermercados:", error);
        this.error = error.message || "Erro ao carregar supermercados";
      } finally {
        this.loading = false;
      }
    },

    getStatusColor(status) {
      if (status === true || status === "ativo" || status === "active") {
        return "success";
      } else if (status === false || status === "inativo" || status === "inactive") {
        return "secondary";
      }
      return "info";
    },

    getStatusText(status) {
      if (status === true || status === "ativo" || status === "active") {
        return "Ativo";
      } else if (status === false || status === "inativo" || status === "inactive") {
        return "Inativo";
      }
      return "Desconhecido";
    },

    async showProducts(supermercado) {
      this.showProductsModal = true;
      this.selectedSupermarketForProducts = supermercado;
      this.loadingProducts = true;
      this.productsData = [];
      this.productsError = null;

      try {
        const response = await apiRequest(API_ENDPOINTS.SUPERMARKET_PRODUCTS_PRICES(supermercado.id), {
          method: "GET",
        });

        const data = await handleApiResponse(response);
        this.productsData = Array.isArray(data) ? data : (data.prices || data.data || data.products || []);
      } catch (error) {
        console.error("Erro ao carregar produtos do supermercado:", error);
        this.productsError = error.message || "Erro ao carregar produtos do supermercado";
      } finally {
        this.loadingProducts = false;
      }
    },

    closeProductsModal() {
      this.showProductsModal = false;
      this.selectedSupermarketForProducts = null;
      this.productsData = [];
      this.productsError = null;
    },

    async deactivateProductPrice(item) {
      const id = item.id ?? item.id_price;

      const result = await showConfirmAlert(
        "Desativar Produto",
        `Tem certeza que deseja desativar "${item.product?.name || 'este produto'}" neste supermercado?`,
        "Sim, desativar",
        "Cancelar"
      );
      if (!result.isConfirmed) return;

      this.deactivatingPriceIds.add(id);

      try {
        await handleApiResponse(
          await apiRequest(API_ENDPOINTS.FLYER_PRODUCT_PRICE_DEACTIVATE(id), {
            method: "PATCH",
          })
        );

        this.productsData = this.productsData.filter((p) => (p.id ?? p.id_price) !== id);
        await showSuccessAlert("Produto desativado!", "O produto foi desativado neste supermercado.", 3000);
      } catch (error) {
        console.error("Erro ao desativar produto:", error);
        showErrorAlert("Erro ao desativar produto", error.message || "Erro ao desativar produto");
      } finally {
        this.deactivatingPriceIds.delete(id);
      }
    },

    getProductImageUrl(item) {
      const path = item.product?.image || item.image || item.product?.image_path || item.image_path;
      if (!path) return null;
      if (/^https?:\/\//i.test(path)) return path;
      return `${STORAGE_BASE_URL}/${String(path).replace(/^\/+/, "")}`;
    },

    async openLogsModal(supermercado) {
      this.showLogsModal = true;
      this.logsSupermarket = supermercado;
      this.loadingLogs = true;
      this.logsError = null;
      this.flyerLogs = [];

      try {
        const response = await apiRequest(API_ENDPOINTS.FLYERS_SUPERMARKET(supermercado.id), {
          method: "GET",
        });

        const data = await handleApiResponse(response);
        this.flyerLogs = Array.isArray(data) ? data : (data.data || data.flyers || data.logs || []);
      } catch (error) {
        console.error("Erro ao carregar logs de folhetos:", error);
        this.logsError = error.message || "Erro ao carregar logs de folhetos";
      } finally {
        this.loadingLogs = false;
      }
    },

    closeLogsModal() {
      this.showLogsModal = false;
      this.logsSupermarket = null;
      this.loadingLogs = false;
      this.logsError = null;
      this.flyerLogs = [];
    },

    formatPrice(price) {
      if (!price && price !== 0) return "0,00";
      const numPrice = typeof price === "string" ? parseFloat(price.replace(",", ".")) : parseFloat(price);
      if (isNaN(numPrice)) return "0,00";
      return numPrice.toFixed(2).replace(".", ",");
    },

    formatDateTime(value) {
      if (!value) return "N/A";
      const date = new Date(value);
      if (isNaN(date)) return value;
      return date.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    formatDateShort(value) {
      if (!value) return "—";
      try {
        const parts = String(value).split("T")[0].split("-");
        if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
        return new Date(value).toLocaleDateString("pt-BR");
      } catch {
        return value;
      }
    },

    getFlyerImageUrl(log) {
      const path = log.image_path || log.image || log.image_url || log.flyer_image;
      if (!path) return null;
      if (/^https?:\/\//i.test(path)) return path;
      return `${STORAGE_BASE_URL}/${String(path).replace(/^\/+/, "")}`;
    },

    openImageLightbox(url) {
      this.lightboxImageUrl = url;
      this.showImageLightbox = true;
    },

    closeImageLightbox() {
      this.showImageLightbox = false;
      this.lightboxImageUrl = null;
    },

    getUserName(log) {
      const candidate = log.user || log.user_name || log.created_by || log.added_by;
      if (candidate && typeof candidate === "object") {
        return candidate.name || "N/A";
      }
      return candidate || "N/A";
    },

    isExpired(value) {
      if (!value) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const parts = String(value).split("T")[0].split("-");
      const expDate = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      return expDate < today;
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.modal-dialog {
  width: 100%;
  margin: 0.5rem auto;
}

@media (max-width: 576px) {
  .modal-dialog {
    max-width: calc(100% - 1rem);
    margin: 0.5rem;
  }
}

.btn-custom-gradient {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-custom-gradient:hover {
  background: linear-gradient(310deg, #15a8d1 0%, #1bb88a 100%);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(23, 193, 232, 0.3);
}

.spinner-teal {
  color: #20c997 !important;
}

.supermercado-card {
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.supermercado-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.supermercado-icon {
  color: #17c1e8;
}

.modal-dialog.modal-lg,
.modal-dialog.modal-xl {
  max-height: 80vh;
}

.modal-dialog.modal-lg .modal-content,
.modal-dialog.modal-xl .modal-content {
  max-height: 80vh;
  overflow-y: auto;
}

.modal-dialog.modal-lg .modal-body,
.modal-dialog.modal-xl .modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

.products-table-wrap {
  max-height: 420px;
  overflow-y: auto;
}

.product-row-thumb {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
}

.btn-outline-info {
  border: 1.5px solid #17c1e8;
  color: #17c1e8;
  background: transparent;
  font-weight: 600;
  transition: all 0.2s ease;
}

.btn-outline-info:hover {
  background: rgba(23, 193, 232, 0.08);
  color: #17c1e8;
}

.flyer-logs-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.flyer-log-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid #eef0f4;
  border-radius: 10px;
  background: #fafbfc;
}

.flyer-log-main {
  display: flex;
  gap: 14px;
}

.flyer-log-thumb {
  width: 72px;
  height: 72px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.flyer-log-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.flyer-log-no-img {
  font-size: 1.6rem;
  color: #ced4da;
}

.flyer-log-thumb--clickable {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.flyer-log-thumb--clickable:hover {
  opacity: 0.8;
}

.image-lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
}

.image-lightbox-img {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
  cursor: default;
}

.image-lightbox-close {
  position: absolute;
  top: 24px;
  right: 32px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.image-lightbox-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.flyer-log-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
}

.flyer-log-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 0.8rem;
}

.flyer-log-label {
  color: #8392a5;
  font-weight: 600;
}

.flyer-log-value {
  color: #344767;
  font-weight: 600;
  text-align: right;
}

.flyer-log-footer {
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
}
</style>
